import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DashCard from "./DashCard";
import FinancialTrends from "./FinancialTrends";
import { fetchData } from "../../features/fetch/fetchSlice";
import DashSubCard from "./DashSubCard";
import TopDisbursements from "./TopDisbursements";
import DisbursementPieChart from "./DisbursementPieChart";
import CollectionPieChart from "./CollectionPieChart";
import RecentActivity from "./RecentActivity";
import RecentDisbursement from "./RecentDisbursement";
import { normalizeDateToLocal } from "../../utils";
import dayjs from "dayjs";
import CardLoading from "../../components/CardLoading";

function DashboardList() {
  const url = "api/v2/dashboard/fetch-dashboard";
  const urlCat = "api/v1/payments/fetch-payment-categories";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    dateRange: null,
    selectSubCat: null,
  });
 
  async function fetchDashboardData() {
    const [startDate, endDate] = formData?.dateRange || [];
    await dispatch(
      fetchData({
        url: url,
        startDate: formData?.day
          ? normalizeDateToLocal(dayjs())
          : normalizeDateToLocal(startDate),
        endDate: formData?.day
          ? normalizeDateToLocal(dayjs())
          : normalizeDateToLocal(endDate),
        pcId: formData?.selectSubCat,
      })
    );
  }

  async function fetchCatData() {
    await dispatch(
      fetchData({
        url: urlCat,
        start: 0,
        limit: null,
      })
    );
  }

const memoizedFormData = useMemo(() => formData, [
  formData.dateRange?.[0],
  formData.dateRange?.[1],
  formData.selectSubCat,
  formData.day
]);

useEffect(() => {
  fetchDashboardData();
  fetchCatData();
}, [user, memoizedFormData]);

 

  if (loading && !formData) return <CardLoading />;
  return (
    <div className=" px-3  w-full h-full overflow-y-scroll">
      <div className=" ml-10 lg:ml-0 mt-[15px]">
        <h1 className="text-[20px] font-[500] text-[#0A0A0A]">
          Welcome, {user?.orgName}
        </h1>
        <p className="text-[13px] font-[500] text-[#575050]">
          Here's a summary of payment activity
        </p>
      </div>

      <DashCard />

      <DashSubCard />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-[.68rem] mt-[1.25rem] w-full">
        <FinancialTrends formData={formData} setFormData={setFormData} />
        <TopDisbursements />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-[.68rem] mt-[1.25rem] w-full">
        <DisbursementPieChart formData={formData} setFormData={setFormData} />
        <CollectionPieChart />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-[.68rem] mt-[1.25rem] w-full">
        <RecentActivity />
        <RecentDisbursement />
      </div>
    </div>
  );
}

export default DashboardList;
